// element argument can be a selector string
//   for an individual element
const mainCarousel = document.querySelector('.main-carousel');
const productSlider = document.querySelector('.product-slider');

if (mainCarousel) {
  var flkty = new Flickity( '.main-carousel', {
    cellAlign: "left",
    autoPlay: 5000,
    pauseAutoPlayOnHover: true,
    imagesLoaded: true,
    setGallerySize: false,
    adaptiveHeight: false,
    wrapAround: true,
    prevNextButtons: true,
    pageDots: false,
    selectedAttraction: 0.15,
    friction: 0.8
  }); 
}

if (productSlider) {
  var productflkty = new Flickity( '.product-slider', {
    cellAlign: "left",
    imagesLoaded: true,
    setGallerySize: true,
    wrapAround: true,
    prevNextButtons: false,
    pageDots: true,
    selectedAttraction: 0.15,
    friction: 0.8,
    adaptiveHeight: true
  }); 
}